class PinnedPostLimitError extends Error {
    constructor(message, pinnedPosts = []) {
        super(message);
        this.name = 'PinnedPostLimitError';
        this.pinnedPosts = pinnedPosts;
    }
}

export default PinnedPostLimitError;
